export default "__VITE_ASSET__CjKSWkiT__"